const aiPromptSettingsDanish = {
  header: {
    title: "AI Indstillinger",
    description: "Tilpas hvordan AI'en genererer dine LinkedIn-opslag"
  },
  sections: {
    profiles: {
      title: "LinkedIn Profiler",
      description: "Tilføj links til LinkedIn-profiler, hvis stil du gerne vil efterligne."
    },
    products: {
      title: "Produkter",
      description: "Tilføj dine produkter eller services, som AI'en kan referere til i opslagene."
    },
    leadMagnets: {
      title: "Lead Magnets",
      description: "Tilføj gratis ressourcer eller lead magnets, som du vil tilbyde i dine opslag."
    },
    examples: {
      title: "Eksempler på Gode Opslag",
      description: "Tilføj eksempler på vellykkede LinkedIn-opslag som AI'en kan lære fra."
    },
    callToAction: {
      title: "Call-to-Action Indstillinger",
      description: "Styrer hvor ofte dine opslag skal indeholde et call-to-action."
    },
    emoji: {
      title: "Emoji Indstillinger",
      description: "Styrer hvor mange emojis dine opslag skal indeholde."
    },
    language: {
      title: "Opslagssprog",
      description: "Vælg hvilket sprog dine opslag skal genereres på. Dette påvirker kun sproget i opslagene, ikke brugergrænsefladens sprog."
    }
  },
  buttons: {
    add: {
      profile: "Tilføj Profil",
      product: "Tilføj Produkt",
      leadMagnet: "Tilføj Lead Magnet",
      example: "Tilføj Eksempel"
    }
  },
  modal: {
    titles: {
      addProfile: "Tilføj LinkedIn Profil",
      editProfile: "Rediger LinkedIn Profil",
      addProduct: "Tilføj Produkt",
      editProduct: "Rediger Produkt",
      addLeadMagnet: "Tilføj Lead Magnet",
      editLeadMagnet: "Rediger Lead Magnet",
      addExample: "Tilføj Eksempel på Godt Opslag",
      editExample: "Rediger Eksempel på Godt Opslag"
    },
    placeholders: {
      profile: "LinkedIn profillink (f.eks. https://www.linkedin.com/in/johndoe)",
      productName: "Produktnavn",
      productDescription: "Beskrivelse af produktet og dets funktioner",
      leadMagnetName: "Lead magnet navn",
      leadMagnetDescription: "Beskrivelse af ressourcen og dens værdi",
      example: "Indsæt et eksempel på et godt LinkedIn-opslag"
    },
    buttons: {
      cancel: "Annuller",
      add: "Tilføj",
      save: "Gem ændringer"
    }
  },
  ctaFrequency: {
    always: "Altid",
    every2: "Hvert 2. opslag",
    every3: "Hvert 3. opslag",
    every4: "Hvert 4. opslag",
    never: "Aldrig",
    withCta: "Med CTA",
    withoutCta: "Uden CTA"
  },
  emojiFrequency: {
    none: "Ingen",
    few: "En smule",
    medium: "Middel",
    many: "Mange",
    examples: {
      none: "Opslag uden emojis.",
      few: "Få emojis 👍",
      medium: "Moderat med emojis 👋 til at fremhæve vigtige pointer ✅",
      many: "Mange emojis 🚀 for energisk tekst 🔥 der fanger øjnene 👀 og skaber engagement 💪"
    }
  },
  preferredEmojis: {
    label: "Foretrukne emojis:",
    placeholder: "Indtast dine foretrukne emojis (fx: 🚀 ✨ 💪 🔥 👍)",
    description: "AI'en vil prioritere disse emojis i dine opslag, men stadig bruge andre for at sikre variation."
  },
  postLanguage: {
    examples: {
      da: "Dette er et eksempel på et opslag på dansk. AI'en vil generere indhold på dette sprog.",
      en: "This is an example of a post in English. The AI will generate content in this language.",
      no: "Dette er et eksempel på et innlegg på norsk. AI-en vil generere innhold på dette språket.",
      sv: "Detta är ett exempel på ett inlägg på svenska. AI:n kommer att generera innehåll på detta språk."
    },
    previewHeader: "Eksempel på opslag"
  },
  save: {
    success: "Indstillinger gemt!",
    error: "Fejl ved gemning. Prøv igen."
  },
  customerBanner: "Du redigerer AI indstillinger for {customerName}",
  about: {
    title: "Om dig selv",
    label: "Fortæl AI'en om din baggrund og ekspertise", 
    placeholder: "Eksempel: Jeg er digital marketingkonsulent med 8 års erfaring inden for e-commerce. Jeg specialiserer mig i SEO, Google Ads og conversion optimization. Jeg hjælper små og mellemstore virksomheder med at øge deres online salg...",
    helpText: "Dette felt giver AI'en værdifuld kontekst om din professionelle baggrund, branche og ekspertise. Informationen bruges til at skabe mere relevante og autentiske opslag, men nævnes ikke direkte medmindre det er særligt relevant."
  },
  customPrompt: {
    title: "Brugerdefineret System Prompt",
    description: "Tilføj dine egne instruktioner til AI'en. Dette er kun for avancerede brugere der ønsker at justere systemprompten.",
    label: "Ekstra instruktioner til AI'en (valgfrit)",
    placeholder: "Eksempel: 'Skriv altid i en meget personlig og humoristisk tone' eller 'Fokuser på at stille spørgsmål til læserne i slutningen af hvert opslag'",
    warning: "Advarsel: Dette felt er til avancerede brugere. Forkerte instruktioner kan påvirke kvaliteten af dine opslag negativt. Lad feltet være tomt hvis du er i tvivl."
  }
};

export default aiPromptSettingsDanish; 